/* Foundation v2.1.4 http://foundation.zurb.com */
/* Artfully masterminded by ZURB  */

import $ from 'jquery';

$(document).ready(function() {
    var switched = false;
    var updateTables = function() {
        if (($(window).width() < 767) && !switched ){
            switched = true;
            $('table.standardtable').each(function(i, element) {
                splitTable($(element));
            });
            return true;
        }
        else if (switched && ($(window).width() > 767)) {
            switched = false;
            $('table.standardtable').each(function(i, element) {
                unsplitTable($(element));
            });
        }
    };

    updateTables();
    $(window).on('redraw',function(){switched=false;updateTables();});
    $(window).on('resize', updateTables);


    function splitTable(original) {
        original.wrap('<div class="table-wrapper">');
        original.wrap('<div class="scrollable">');
    }

    function unsplitTable(original) {
        original.unwrap();
        original.unwrap();
    }
});
